import * as IoC from 'typescript-ioc';
import * as mobx from 'mobx';
import { Unsubscribe } from 'router5/dist/types/base';
import { IModuleVM } from '../../infrastructure/components/module-vm';
import { IRouter } from '../../infrastructure/router';
import { RouteParams, Routes } from '../../routes-table';
import TrackingServiceProvider from '../../tracking-service/tracking-service-provider';
import { OE_DATA_TRACKING_EVENTS } from '../../tracking-service/tracking-values';
import { OeDataOrganizationsVM } from './_organizations/oe-data-organizations.viewmodel';

export enum OeDataTab {
    Organizations,
}

export class OeDataVM implements IModuleVM {
    @mobx.observable
    private activeTab: OeDataTab = OeDataTab.Organizations;
    private subscriptions: Unsubscribe[] = [];
    private readonly organizationsVM: OeDataOrganizationsVM = new OeDataOrganizationsVM();

    constructor(
        @IoC.Inject private readonly routingService: IRouter<RouteParams> = IoC.Container.get(IRouter),
        @IoC.Inject private readonly trackingService: TrackingServiceProvider = IoC.Container.get(TrackingServiceProvider),
    ) {}

    public didMount(): void {
        this.initRouterSubscriptions();
    }

    public willUnmount(): void {
        this.subscriptions.forEach(x => x());
        this.subscriptions = [];
        this.organizationsVM.disposeReactions();
    }

    @mobx.action.bound
    public setActiveTab(tab: OeDataTab): void {
        this.activeTab = tab;
    }

    public getActiveTab(): OeDataTab {
        return this.activeTab;
    }

    public getOrganizationsVM(): OeDataOrganizationsVM {
        return this.organizationsVM;
    }

    private initRouterSubscriptions(): void {
        this.subscriptions.push(this.routingService.listen(Routes.OeDataOrganizations, () => {
            this.setActiveTab(OeDataTab.Organizations);
            this.organizationsVM.fetchOrganizations();
            this.trackingService.get().track(OE_DATA_TRACKING_EVENTS.VIEW_OE_DATA, { 'Tab': 'Organizations' });
        }));
    }
}
